import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "./book.PNG";
import imagehead from "./kacot_web_design_page_biography_color_and_theme_likes__ddcd560e-156a-48c7-addd-16867686972e.png";
import Searchengine from "./Searchengine";
import Results from "./Results";
import "./App.css";
import ListSynonyms from "./ListSynonyms";

function HomeLayout() {
  return (
    <div className="Homepage">
      <header className="App-header">
        <img src={logo} className="App-logo" alt="Go back to Homepage" />
        <h1 className="tittle">Dictionary</h1>
      </header>
      <img src={imagehead} className="illustration" alt="illustration"></img>
      <h1>Search for a word</h1>

      <div className="searchengine">
        <Searchengine />
      </div>
      <footer className="footer">Coded by Kathleen Cocodeau</footer>
    </div>
  );
}

function ResultPage() {
  return (
    <div className=" ResultPage">
      <header className="ResultPage-header">
        <div className="d-flex align-items-center justify-content-center">
          <Link to="/">
            <img src={logo} className="App-logo" alt="Got back to Homepage" />
          </Link>
          <h1 className="tittle">Dictionary</h1>
        </div>
        <h2 className="tittle ms-5 fs-1 fst-italic d-flex justify-content-center">
          Definitions
        </h2>
      </header>
      <Results />
      <footer className="footer">Coded by Kathleen Cocodeau</footer>
    </div>
  );
}

function SynonymsPage() {
  return (
    <div className="SynonymsPage">
      <header className="ResultPage-header">
        <div className="d-flex align-items-center justify-content-center">
          <Link to="/">
            <img src={logo} className="App-logo" alt="Got back to Homepage" />
          </Link>
          <h1 className="tittle">Dictionary</h1>
        </div>
        <h2 className="tittle ms-5 fs-1 fst-italic d-flex justify-content-center">
          Synonyms & Antonyms
        </h2>
      </header>
      <ListSynonyms />
      <footer className="footer">Coded by Kathleen Cocodeau</footer>
    </div>
  );
}

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomeLayout />} />
        <Route path="/results" element={<ResultPage />} />
        <Route path="/synonyms" element={<SynonymsPage />} />
      </Routes>
    </Router>
  );
}

export default App;
